import axiosInstance from "./AxiosInstance";
import config from "../config";

export const fetchAllReports = () => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.reports,
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createReport = (id, data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.createReport(id),
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const updateReport = (id, data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.role(id),
    method: "put",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};

export const deleteReport = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result?.token;

  return axiosInstance({
    url: config.routes.role(id),
    method: "delete",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
